import { type HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export function ContentContainer({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'mx-auto flex min-h-0 w-full flex-1 flex-col px-4 sm:px-6 lg:px-8',
        className,
      )}
      {...props}
    />
  );
}
